import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/.pnpm/@apollo+client-react-streaming@0.12.3_@apollo+client@3.14.0_@types+react@19.2.7_graphql_c0c766c31ff4aebbf1d458a7a578c58f/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["Role"] */ "/opt/build/repo/node_modules/.pnpm/@ariakit+react@0.4.17_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/@ariakit/react/esm/index.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@next+third-parties@16.0.10_next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_re_851ce30b7d8be78d69a6d1bd9c8727cd/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@next+third-parties@16.0.10_next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_re_851ce30b7d8be78d69a6d1bd9c8727cd/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@next+third-parties@16.0.10_next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_re_851ce30b7d8be78d69a6d1bd9c8727cd/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/arrow-diagonal.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/arrow-down.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/arrow-left.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/arrow-level-down.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/arrow-up.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/camera.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/card-logo.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/cc-off.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/cc-on.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/check.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/chevron.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/close.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/envelope.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/expanding-arrow-diagonal.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/expanding-arrow-left.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/expanding-arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/facebook-square.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/filter.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/globe.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/great-wall-grid.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/great-wall-scroller.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/headphone-off.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/headphone.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/line-diagonal.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/line.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/link.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/loading.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/location-pin.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/lock.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-404.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-dynamic.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-empowering.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-footer.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-large.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-news.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-pristine.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-reverential.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo-worded.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/logo.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/maximize.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/microphone.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/minimize.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/minus.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/pause.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/pdf.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/phone.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/play.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/plus.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/print.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/reload.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/search.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/share.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/sort.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/threads.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/tick.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/twitter.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/union.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/user.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/volume.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/youtube.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/button/button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/call-to-action/call-to-action.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CardLogo"] */ "/opt/build/repo/src/ui/components/cards/base/CardLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpandableProvider","ExpandableContent"] */ "/opt/build/repo/src/ui/components/expandable/client.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/fullBleedCta/fullBleedCta.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/icon/icon.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/call-for-concepts/call-for-concepts.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/cards/highlight/highlight.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/cards/landing/landing.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/carousel/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/column/column.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/context.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/link/link.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/quickLinks/quickLinks.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/content-grid/content-grid.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/faq/faq.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/faqs/faqs.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/cards/base/base.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/grantmakingAreasGrid/grantmakingAreasGrid.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/heroAsset/heroAsset.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/image/image.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/initiativeQuote/initiativeQuote.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/inlineImages/inlineImages.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/parallaxImages/parallaxImages.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/quote/quote.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/richText/richText.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/spotlight/spotlight.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/video/video.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/styles/truncate.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/styles/spacing.module.scss");
